import { useEffect, useRef } from 'react';
import { Box } from '@mui/system';
import Drawer from '@mui/material/Drawer';
import { Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Avatar from '@mui/material/Avatar';

import theme from 'src/style-system/theme';
import { ICountryList } from '@utils/types';
import useClickOutside from '@utils/useClickOutside';
import TCCLOGO from 'svgComponents/TccLogo';

import { useStyles } from './useStyles';

interface ICountryDrawer {
  getServiceableCountries: ICountryList[] | undefined;
  isCountryDrawerOpen: boolean;
  setCountryDrawerOpen: (open: boolean) => void;
  onClickCountry?: (countryCode: string) => void;
}

const CountryDrawer = ({
  getServiceableCountries,
  isCountryDrawerOpen,
  setCountryDrawerOpen,
  onClickCountry,
}: ICountryDrawer) => {
  const ref = useRef<HTMLDivElement>(null);

  const classes = useStyles();

  useEffect(() => {
    if (isCountryDrawerOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [isCountryDrawerOpen]);

  useClickOutside(ref, () => {
    setCountryDrawerOpen(false);
  });

  const onHandleClickCountry = (country: ICountryList) => {
    onClickCountry && onClickCountry(country?.country_code);
  };

  return (
    <Drawer
      className={classes.countryDrawer}
      variant="persistent"
      anchor="left"
      open={isCountryDrawerOpen}
    >
      <Box
        bgcolor="whitePepper.main"
        sx={{
          height: '100vh',
          [theme.breakpoints.down('sm')]: {
            width: '100%',
          },
        }}
        ref={ref}
      >
        <Box className={classes.mainConatiner}>
          <Box className={classes.headerContainer}>
            <TCCLOGO />
            <IconButton onClick={() => setCountryDrawerOpen(false)}>
              <CloseIcon fontSize="large" sx={{ color: 'cumin.main' }} />
            </IconButton>
          </Box>
          <Box className={classes.countryListContainer}>
            {getServiceableCountries
              ?.filter((country) => country.country_code !== 'can')
              .map((country) => (
                <Box
                  key={country.id}
                  className={classes.countryContainer}
                  onClick={() => onHandleClickCountry(country)}
                >
                  <Avatar
                    src={country.country_flag}
                    alt={country.iso_alpha_2_code}
                  />
                  <Typography variant="body1" align="left" color="cumin.main">
                    {country.country_name}
                  </Typography>
                </Box>
              ))}
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

export default CountryDrawer;
